import { memo } from 'react';
import cn from 'classnames';
import type { NodeToRenderProps, NodeToRenderData } from './types/custom-nodes.type';
import { applyEndIfConditionHocs } from '../../scenario-editor/utils';

export const MenuItem = ({ children, className, ...props }: NodeToRenderProps) => {
  return (
  <div
    className={
      cn([
        "flex rounded-md p-2 border-2 border-transparent bg-input h-full justify-center items-center w-fit text-sm truncate",
        className,
      ])
    }
    {...props}
  >{children}</div>
)};

export const NodeItem = ( props: NodeToRenderProps) => {
  return (
    <div
      className={
        cn([
          props.className,
          "flex flex-col content-center py-2 px-2 rounded-md bg-transparent border-2 border-transparent justify-center items-center w-fit text-sm cursor-auto",
        ])
      }
      style={props.style}
    >
      <div className="bg-gray-400 min-w-2 min-h-2 rounded-lg"></div>
    </div>
  )
};

const WrappedNodeToRender = applyEndIfConditionHocs(NodeItem);

const IfClose: React.FC<NodeToRenderProps> = (props: NodeToRenderProps) => {
  const { title } = props.data as NodeToRenderData;
  return (
    <>
      <WrappedNodeToRender {...props}>{title}</WrappedNodeToRender>
    </>
  );
};

export const IfCloseNode = memo(IfClose);
